import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import Select from "react-select";
import moment from "moment";
import { academylist, workerlist } from "../../../services/admin";
import { roleList } from "../../../services/master";

// Read-only worker report. Pick academy (super-admin) and optionally a worker
// type, then the matching workers are shown in an ag-grid table (sort/filter per
// column) and can be exported to CSV. Mirrors the other report screens.
const WorkerReport = () => {
  const isSuperAdmin = localStorage.getItem("Role") === "1";

  const [aclist, setACList] = useState([]);
  const [acaid, setAcaID] = useState("");
  const [wlist, setWlist] = useState([]);
  const [wtype, setWType] = useState("");
  const [sphoto, setSPhoto] = useState("");
  const [rowData, setRowData] = useState([]);

  function errorphoto(ev) {
    ev.target.src = require("../../../assets/images/teacher.jpg");
    ev.target.onerror = null;
  }

  const columnDefs = [
    {
      headerName: "Photo",
      width: 90,
      field: "worker_photo",
      resizable: true,
      filter: false,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <img
              src={sphoto + params.value}
              onError={errorphoto}
              style={{ height: "50px", width: "50px" }}
            />
          </div>
        );
      },
    },
    { headerName: "Name", field: "worker_name", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "Username", field: "username", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "Emp ID", field: "employee_id", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "Type", field: "type_name", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    {
      headerName: "Date of Birth",
      field: "dob",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellRenderer: (params) =>
        params.value ? moment(params.value).format("DD-MM-YYYY") : "",
    },
    { headerName: "Blood Group", field: "blood_group", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "Gender", field: "gender", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "Phone Number", field: "phone", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "Qualification", field: "qualification", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "State", field: "state_name", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "District", field: "district", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "City", field: "city", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "Pincode", field: "pincode", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "Academy", field: "academy_name", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
  ];

  useEffect(() => {
    // Worker types are the roles with id > 5 (same source as the Add Worker form).
    roleList().then((res) => {
      if (res.status === true) {
        setWlist((res.data || []).filter((item) => item.id > 5));
      }
    });

    academylist().then((res) => {
      if (res.status === true && res.data.details.length > 0) {
        const arr = res.data.details.map((item) => ({
          value: item.id,
          label: item.name + " - " + item.code,
        }));
        setACList(arr);

        // Default to the academy chosen at login (matches other report screens).
        let defaultAca = "";
        if (localStorage.getItem("AAcademy") != null) {
          defaultAca =
            arr.find((a) => a.value == localStorage.getItem("AAcademy")) || "";
          if (defaultAca) setAcaID(defaultAca);
        }
        loadWorkers(defaultAca, "");
      } else {
        loadWorkers("", "");
      }
    });
  }, []);

  function loadWorkers(academy, type) {
    setRowData([]);
    const temp = new FormData();
    if (isSuperAdmin && academy && academy.value) {
      temp.append("academy_id", academy.value);
    }
    temp.append("status", 1);
    if (type) {
      // API filters workers.type via the `role` param (worker type == role id).
      temp.append("role", type);
    }

    workerlist(temp).then((res) => {
      if (res && res.status === true) {
        let data = res.data.details || [];
        setSPhoto(res.data.path || "");
        // Client-side safeguard in case the API ignores the filter; the worker's
        // type id lives in the `type` field (type_name is the display label).
        if (type) {
          data = data.filter((w) => w.type == type);
        }
        setRowData(data);
      }
    });
  }

  function handleAcademy(e) {
    setAcaID(e || "");
    loadWorkers(e || "", wtype);
  }

  function handleType(e) {
    const val = e.target.value;
    setWType(val);
    loadWorkers(acaid, val);
  }

  const exportToCSV = () => {
    const q = (v) => `"${(v == null ? "" : String(v)).replace(/"/g, '""')}"`;
    const cols = columnDefs.filter((c) => c.field !== "worker_photo");
    const header = cols.map((c) => c.headerName);
    const lines = rowData.map((row) =>
      cols
        .map((c) => {
          let v = row[c.field];
          if (c.field === "dob") v = v ? moment(v).format("DD-MM-YYYY") : "";
          return q(v);
        })
        .join(",")
    );
    const csv = [header.join(","), ...lines].join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Worker Report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Worker Report</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Reports</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Worker Report
          </li>
        </ol>
      </div>
      <div className="content-body">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <h2 className="main-content-title tx-24 mg-b-5">Worker Report</h2>
            </div>
            <div className="card-body">
              <div className="row">
                {isSuperAdmin && (
                  <div className="col-xl-4 col-sm-6">
                    <label className="form-label">Select Academy</label>
                    <Select
                      className="default-select"
                      placeholder="Select Academy"
                      value={acaid}
                      options={aclist}
                      onChange={handleAcademy}
                      isSearchable={true}
                      isClearable
                    />
                  </div>
                )}

                <div className="col-xl-4 col-sm-6">
                  <label className="form-label">Workers Type</label>
                  <select
                    className="default-select form-control wide"
                    value={wtype}
                    onChange={handleType}
                  >
                    <option value="">All Types</option>
                    {wlist.map((item) => (
                      <option value={item.id} key={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-xl-4 col-sm-6">
                  <div className="res-right mt-5">
                    <button
                      className="btn btn-success me-2"
                      onClick={exportToCSV}
                      disabled={rowData.length === 0}
                    >
                      Excel Download
                    </button>
                  </div>
                </div>
              </div>

              <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                  columnDefs={columnDefs}
                  rowData={rowData}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={["asc", "desc"]}
                  suppressDragLeaveHidesColumns={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkerReport;
